import { createContext } from 'react';

import makeContextHoc from 'hoc/makeContextHoc';
import { IBettingReadyIndicatorContext } from './types';

export const BettingReadyIndicatorContext = createContext<IBettingReadyIndicatorContext>(
    {} as IBettingReadyIndicatorContext
);

export const withBettingReadyIndicatorContext = makeContextHoc<
    IBettingReadyIndicatorContext,
    'readyIndicator'
>({
    context: BettingReadyIndicatorContext,
    propName: 'readyIndicator',
});
